export enum SocialNetworkInstancePrivacyType {
  PUBLIC = 'PUBLIC',
  INVITED_ONLY = 'INVITED_ONLY',
  PUBLIC_READ = 'PUBLIC_READ',
  PRIVATE = 'PRIVATE',
}
